(() => {
  if (window.__ckoReviewExcerpt) return;
  window.__ckoReviewExcerpt = true;

  const MARKER = '[data-cko-review-excerpt]';
  const CLAMPED = 'is-clamped';
  let observer;

  const refresh = (scope = document) => {
    const nodes = scope.querySelectorAll ? scope.querySelectorAll(MARKER) : [];
    nodes.forEach((figure) => {
      const body = figure.querySelector('.cko-review-excerpt__body');
      if (!body) return;
      figure.classList.toggle(CLAMPED, body.scrollHeight - body.clientHeight > 1);
      if (observer) observer.observe(body);
    });
  };

  const watch = () => {
    if (window.ResizeObserver && !observer) {
      observer = new ResizeObserver(() => refresh());
    }
    refresh();
  };

  const start = () => requestAnimationFrame(watch);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => refresh(event.target));
})();
